/**
 * This store is responsible for holding information about
 * images being uploaded
 */
 import AppDispatcher from '../dispatcher/app-dispatcher'
 import assign from 'lodash/assign'
 import debounce from "lodash/debounce"
 import noop from "lodash/noop"
 import isUndefined from "lodash/isUndefined"

 const EventEmitter = require('events').EventEmitter
 const CHANGE_EVENT = 'change';

var storeData = {
    userToken: null
};

function updateToken(token) {
    storeData.userToken = token;
}

var UserStore = assign({}, EventEmitter.prototype, {
    dispatcherIndex: AppDispatcher.register(function (payload) {
        var action = payload.action;
        switch (action.actionType) {
            case 'updateUserToken':
                updateToken(action.userToken);
                UserStore.emitChange();
                break;
        }
        return true;
    }),
    getData: function () {
        return storeData;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    addChangeListener: function (callback) {
        this.addListener(CHANGE_EVENT, callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

export default UserStore;
